export const DAG_NODE = 250000;
export const PLATFORM_FEE = 0.2;
